/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ChangeEvent, useEffect, useRef, useState } from 'react'

import 'react-circular-progressbar/dist/styles.css'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { CircularProgressbar } from 'react-circular-progressbar'

import UiSelect from '../../components/UI/UISelect'
import UIButton from '../../components/UI/UIButton'
import UITextInput from '../../components/UI/UITextInput'
import UIDatePickerv from '../../components/UI/UIDatePickerv'
import UIDocumentPicker from '../../components/UI/UIDocumentPicker'
import UIStaightlineProressBar from '../../components/UI/UIStaightlineProressBar'
import { fileUpload } from '../../api/apiService'
import { Accordion, AccordionItem } from '../candidates/components/Accordion'
import {
  UploadResponse,
  safeguardingCategoriesResponse,
  safeguardingCategoriesResponseObj,
  safeguardingResponse,
  trainingRecords,
} from '../../utils/types'
import {
  getProfileSafeguardingRecord,
  getSafeguardingRecordCategories,
  updateProfileSafeguardingRecord,
} from '../../api/admin/myscrApis'
import {
  calculateNonNullPercentage,
  getSafeguardingScoreFields,
  aggregateSafeguardingScore,
} from '../../utils/utils'
import Modal from '../../components/UI/UIModal'
import { Icon } from '../../components/Icon'

export interface safeguardingRecordsData {
  id?: string
  userId?: string
  safeguardingRecordCategoryId?: string
  verifiedBy?: string
  verifiedByName?: string
  isRejected?: boolean
  verificationDate?: string
  documentType?: string
  documentNo?: string
  document?: string
  riskAssessmentStatus?: string
  issueDate?: string
  expiryDate?: string
  riskDocument?: string
  duration?: string
  title?: string
  referenceUrl?: string
  isExpiryDate?: string
  isIssueDate?: string
  isRiskAssessment?: string
}

export interface createSafeguardingRecordFormDataInterface {
  safeguardingRecordCategoryId?: string
  verifiedBy?: string
  verificationDate?: string
  documentType?: string
  documentNo?: string
  document?: string
  riskAssessmentStatus?: string
  issueDate?: string
  expiryDate?: string
  riskDocument?: string
  duration?: string
  title?: string
}

export interface updateSafeguardingRecordFormDataInterface {
  id?: string
  safeguardingRecordCategoryId?: string
  verifiedBy?: string
  verificationDate?: string
  documentType?: string
  documentNo?: string
  document?: string
  riskAssessmentStatus?: string
  issueDate?: string
  expiryDate?: string
  riskDocument?: string
  duration?: string
  title?: string
}

type AnyObject = { [key: string]: any }
type AnyArray = any[]

function convertNullsToUndefined(
  obj: AnyObject | AnyArray,
  columnsToRemove?: string[]
): AnyObject | AnyArray | undefined {
  if (Array.isArray(obj)) {
    return obj.map((item) => convertNullsToUndefined(item, columnsToRemove))
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc: AnyObject, key: string) => {
      if (!columnsToRemove?.includes(key)) {
        // Check if the key is not in the columns to remove
        acc[key] = convertNullsToUndefined(obj[key], columnsToRemove)
      }
      return acc
    }, {})
  } else {
    return obj === null ? undefined : obj
  }
}

const SafeGuardingRecords = () => {
  const divRef = useRef<HTMLDivElement>(null)
  const [alertActive, setAlertActive] = useState(false)
  const [isOpenAlert, setIsOpenAlert] = useState(false)
  const [isUpdateLoading, setIsUpdateLoading] = useState<boolean>(false)

  const [safeguardingRecordsData, setSafeguardingRecordsData] =
    useState<safeguardingRecordsData[]>()
  const [createRecordFormData, setCreateRecordFormData] = useState<
    createSafeguardingRecordFormDataInterface[]
  >([])
  const [updateRecordFormData, setUpdateRecordFormData] = useState<
    updateSafeguardingRecordFormDataInterface[]
  >([])

  const fetchTrainingRecordCategories =
    async (): Promise<safeguardingCategoriesResponseObj> => {
      const response =
        (await getSafeguardingRecordCategories()) as safeguardingCategoriesResponse
      if (response?.status != 'successful') {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
      return response?.data
    }

  const fetchTrainingRecord = async (): Promise<safeguardingRecordsData[]> => {
    const response =
      (await getProfileSafeguardingRecord()) as safeguardingResponse
    if (response?.status != 'successful') {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
    return response?.data
  }

  const {
    data: safeguardingRecords,
    isLoading: isLoadingRecords,
    isError: isErrorRecords,
    refetch: refetchRecords,
  } = useQuery('userTraining', fetchTrainingRecord, {
    refetchOnWindowFocus: false, // Disable refetch on window focus
    refetchOnReconnect: false, // Disable refetch on network reconnect
  })

  const {
    data: trainingCategories,
    isLoading: isLoadingCategories,
    isError: isErrorCategories,
    refetch: refetchCategories,
  } = useQuery('trainingRecordCategories', fetchTrainingRecordCategories, {
    refetchOnWindowFocus: false, // Disable refetch on window focus
    refetchOnReconnect: false, // Disable refetch on network reconnect
  })

  const convertToUndefined = (value: any) => (value ? value : undefined)

  useEffect(() => {
    if (safeguardingRecords !== undefined) {
      const mergedArray = trainingCategories?.data?.map((category) => {
        const matchingRecords =
          safeguardingRecords?.filter(
            (record) => record.safeguardingRecordCategoryId === category.id
          ) || []
        // If no matching records are found, include only the category title
        if (matchingRecords.length === 0) {
          return {
            title: category.title,
            safeguardingRecordCategoryId: category.id,
            isExpiryDate: category.expiryDate,
            isIssueDate: category.issueDate,
            isRiskAssessment: category.riskAssessment,
            // referenceUrl:category?.referenceUrl
          }
        } else {
          let obj = {}
          matchingRecords?.map((record: any) => {
            const updatedRecord: any = {}
            for (const key in record) {
              // eslint-disable-next-line no-prototype-builtins
              if (record.hasOwnProperty(key)) {
                updatedRecord[key] = convertToUndefined(record[key])
              }
            }
            obj = {
              ...record,
              title: category.title || undefined,
              isExpiryDate: category.expiryDate,
              isIssueDate: category.issueDate,
              isRiskAssessment: category.riskAssessment,
            }
          })
          return obj
        }
      })
      if (mergedArray) setSafeguardingRecordsData(mergedArray)
    }
  }, [safeguardingRecords, trainingCategories])

  useEffect(() => {
    refetchRecords()
  }, [])

  const handleChange = (
    fieldName: string,
    value: string | boolean,
    item: safeguardingRecordsData
  ) => {
    setAlertActive(true)
    if (Object.keys(item)?.length > 3) {
      setSafeguardingRecordsData((prev) => {
        if (!prev) {
          // If previous state is undefined, return a new array with the updated item
          return [
            {
              ...item,
              [fieldName]: value ? value : undefined,
            },
          ]
        }
        // Check if the item exists in the previous state
        const existingItemIndex = prev.findIndex(
          (record) =>
            record.safeguardingRecordCategoryId ===
            item.safeguardingRecordCategoryId
        )
        if (existingItemIndex !== -1) {
          // If the item exists, update the specified field name with the provided value
          return prev.map((record, index) => {
            if (index === existingItemIndex) {
              return {
                ...record,
                [fieldName]: value ? value : undefined,
              }
            }
            return record
          })
        } else {
          // If the item doesn't exist, add it and update the specified field name with the provided value
          return [
            ...prev,
            {
              ...item,
              [fieldName]: value ? value : undefined,
            },
          ]
        }
      })
      setUpdateRecordFormData((prev) => {
        if (!prev) {
          // If previous state is undefined, return a new array with the updated item
          return [
            {
              ...item,
              [fieldName]: value ? value : undefined,
            },
          ]
        }
        // Check if the item exists in the previous state
        const existingItemIndex = prev.findIndex(
          (record) =>
            record.safeguardingRecordCategoryId ===
            item.safeguardingRecordCategoryId
        )
        if (existingItemIndex !== -1) {
          // If the item exists, update the specified field name with the provided value
          return prev.map((record, index) => {
            const { title, ...rest } = record
            if (index === existingItemIndex) {
              return {
                ...rest,
                [fieldName]: value ? value : undefined,
              }
            }
            return record
          })
        } else {
          // If the item doesn't exist, add it and update the specified field name with the provided value
          return [
            ...prev,
            {
              ...item,
              [fieldName]: value ? value : undefined,
            },
          ]
        }
      })
    } else {
      if (fieldName == 'document' || undefined) {
        setSafeguardingRecordsData((prev) => {
          if (!prev) {
            // If previous state is undefined, return a new array with the updated item
            return [
              {
                ...item,
                [fieldName]: value ? value : undefined,
              },
            ]
          }
          // Check if the item exists in the previous state
          const existingItemIndex = prev.findIndex(
            (record) =>
              record.safeguardingRecordCategoryId ===
              item.safeguardingRecordCategoryId
          )
          if (existingItemIndex !== -1) {
            // If the item exists, update the specified field name with the provided value
            return prev.map((record, index) => {
              if (index === existingItemIndex) {
                return {
                  ...record,
                  [fieldName]: value ? value : undefined,
                }
              }
              return record
            })
          } else {
            // If the item doesn't exist, add it and update the specified field name with the provided value
            return [
              ...prev,
              {
                ...item,
                [fieldName]: value ? value : undefined,
              },
            ]
          }
        })
      }
      setCreateRecordFormData((prev) => {
        const matchingRecords =
          prev?.filter(
            (record) =>
              record.safeguardingRecordCategoryId ===
              item.safeguardingRecordCategoryId
          ) || []
        if (matchingRecords.length === 0) {
          const newItem = {
            ...item,
            [fieldName]: value,
          }
          return [...prev, newItem]
        } else {
          const updatedRecords =
            prev?.map((record) => {
              if (
                record.safeguardingRecordCategoryId ===
                item.safeguardingRecordCategoryId
              ) {
                const { title, ...rest } = record
                return {
                  ...rest,
                  [fieldName]: value ? value : undefined,
                }
              }
              return record
            }) || []

          return updatedRecords
        }
      })
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleFileChange = async (
    category: string,
    event: ChangeEvent<HTMLInputElement>,
    item: safeguardingRecordsData
  ) => {
    const file = event.target.files?.[0]
    if (file) {
      try {
        const response = (await fileUpload({
          file: file,
          category: 'user_document',
        })) as UploadResponse
        toast.success(response?.message, {
          position: 'top-right',
        })
        handleChange('document', response?.url, item)
      } catch (error) {
        handleChange('document', item?.document ? item?.document : '', item)
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    }
    event.target.value = ''
  }

  const handleUpdateRecords = async (): Promise<void> => {
    setIsUpdateLoading(true)
    try {
      setIsUpdateLoading(true)

      const convertedValues = convertNullsToUndefined(updateRecordFormData, [
        'isExpiryDate',
        'isIssueDate',
        'documentUrl',
        'riskDocumentUrl',
        'isRiskAssessment',
        'verifiedByName',
        'id',
      ])
      const response = (await updateProfileSafeguardingRecord(
        convertedValues as any
      )) as {
        status?: string
        data: trainingRecords
      }
      if (response?.status == 'successful') {
        setUpdateRecordFormData([])
        refetchCategories()
        refetchRecords()
        toast.success('Records Updated.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('An error occurred while updating records.', {
        position: 'top-right',
      })
    } finally {
      setIsUpdateLoading(false)
    }
  }

  const handleClickOutside = (event: MouseEvent) => {
    if (
      divRef.current &&
      !divRef.current.contains(event.target as Node) &&
      alertActive
    ) {
      setIsOpenAlert(true)
    } else if (isOpenAlert == false) {
      setAlertActive(false)
    }
  }

  useEffect(() => {
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [alertActive])

  // Overall scorecard, shared with the candidate view via utils so the same
  // record scores identically here and on My SCR (Behaviour B).
  const scorecard = aggregateSafeguardingScore(
    trainingCategories?.data,
    safeguardingRecordsData
  )

  return (
    <div ref={divRef}>
      <div className="flex my-8 gap-2">
        {/* First column */}
        <div
          style={{
            // height: 'calc(100vh - 100px)',
            overflow: 'auto',
            // scrollbarWidth: 'none',
          }}
          className="flex flex-col w-8/12 gap-4"
        >
          {safeguardingRecordsData?.map(
            (item: safeguardingRecordsData, index: number) => {
              return (
                <Accordion key={index} defaultActiveIndex={null}>
                  <AccordionItem
                    title={item?.title ? item?.title : ''}
                    isActive={false}
                  >
                    <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                      <div className="flex w-full gap-4">
                        <div className="w-6/12  ">
                          <UiSelect
                            onChange={(e: string) => {
                              handleChange('documentType', e, item)
                            }}
                            value={item?.documentType ? item?.documentType : ''}
                            options={[
                              { value: 'Passport', label: 'Passport' },
                              {
                                value: 'Driving License',
                                label: 'Driving License',
                              },
                              {
                                value: 'Birth Certificate',
                                label: 'Birth Certificate',
                              },
                              {
                                value: 'Certificate',
                                label: 'Certificate',
                              },
                              {
                                value: 'Other',
                                label: 'Other',
                              },
                            ]}
                            title={'Document Type'}
                          />
                        </div>
                        <div className="w-6/12  ">
                          <UITextInput
                            placeholder={'Document No'}
                            label={'Document No'}
                            iconName={''}
                            value={item?.documentNo ? item?.documentNo : ''}
                            onChange={(e) =>
                              handleChange('documentNo', e.target.value, item)
                            }
                          />
                        </div>
                      </div>

                      <UIDocumentPicker
                        id={item?.title ? item?.title : 'pickerInput'}
                        handleRemoveFile={() => {
                          handleChange('document', '', item)
                        }}
                        label={'Document'}
                        initialValue={item?.document ? item?.document : ''}
                        onChange={(e) => handleFileChange('document', e, item)}
                        accept=".pdf, .doc, .docx, .jpg, .jpeg, .png, .svg"
                        labelClassName="custom-label-class"
                      />

                      <div className="flex w-full gap-4">
                        {item.isIssueDate && (
                          <div className="w-6/12  ">
                            <UIDatePickerv
                              placeholderText={'Not Specified'}
                              title={'Issue Date'}
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                handleChange('issueDate', e.target.value, item)
                              }}
                              value={
                                item?.issueDate
                                  ? item?.issueDate.split('T')[0]
                                  : ''
                              }
                            />
                          </div>
                        )}
                        {item.isExpiryDate && (
                          <div className="w-6/12">
                            <UIDatePickerv
                              placeholderText={'Not Specified'}
                              title={'Expiry Date'}
                              value={
                                item?.expiryDate
                                  ? item?.expiryDate.split('T')[0]
                                  : ''
                              }
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                handleChange('expiryDate', e.target.value, item)
                              }}
                            />
                          </div>
                        )}
                      </div>
                      <div className="flex w-full gap-4">
                        <div className="w-6/12  ">
                          <UITextInput
                            readOnly
                            placeholder={'Not specified'}
                            label={'Verified by'}
                            iconName={''}
                            value={item?.verifiedByName || ''}
                            // onChange={(e) =>
                            //   handleChange('verifiedBy', e.target.value, item)
                            // }
                          />
                        </div>
                        <div className="w-6/12">
                          <UIDatePickerv
                            readOnly
                            placeholderText={'Not Specified'}
                            title={'Verification Date'}
                            value={
                              item?.verificationDate
                                ? item?.verificationDate.split('T')[0]
                                : ''
                            }
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              handleChange(
                                'verificationDate',
                                e.target.value,
                                item
                              )
                            }}
                          />
                        </div>
                      </div>
                      {/* {item.isRiskAssessment && (
                        <>
                          <div className="flex w-full gap-4">
                            <div className="w-6/12  ">
                              <UiSelect
                                disabled={true}
                                options={[
                                  { value: 'yes', label: 'YES' },
                                  { value: 'no', label: 'NO' },
                                ]}
                                title={'Risk Assessment Status'}
                                value={
                                  item?.riskAssessmentStatus
                                    ? item?.riskAssessmentStatus
                                    : ''
                                }
                                onChange={(e: string) => {
                                  handleChange('riskAssessmentStatus', e, item)
                                }}
                              />
                            </div>
                            <div className="w-6/12">
                              <UiSelect
                                disabled={true}
                                value={item?.duration}
                                options={[
                                  { value: '12 Months', label: '12 Months' },
                                  { value: '9 Months', label: '9 Months' },
                                  { value: '6 Months', label: '6 Months' },
                                  { value: '3 Months', label: '3 Months' },
                                  { value: '0 Months', label: '0 Months' },
                                ]}
                                title={'Duration'}
                                onChange={(e: string) => {
                                  handleChange('duration', e, item)
                                }}
                              />
                            </div>
                          </div>
                          <UIDocumentPicker
                            id={item?.title ? item?.title : 'pickerInput'}
                            handleRemoveFile={() => {
                              handleChange('riskDocument', '', item)
                            }}
                            label={'Risk Assesment Document'}
                            initialValue={
                              item?.riskDocument ? item?.riskDocument : ''
                            }
                            onChange={(e) =>
                              handleRiskFileChange('riskDocument', e, item)
                            }
                            accept=".pdf, .doc, .docx, .jpg, .jpeg, .png, .svg"
                            labelClassName="custom-label-class"
                          />
                        </>
                      )} */}
                    </div>
                  </AccordionItem>
                </Accordion>
              )
            }
          )}
        </div>

        {/* Second column */}
        <div className="w-4/12">
          <Accordion defaultActiveIndex={0}>
            <AccordionItem
              title={'Scorecard'}
              isActive={true}
              AccordionItemStyle={{
                backgroundColor: 'rgba(230, 240, 243, 1)',
              }}
              AccordiontitleStyle={
                'text-sm text-bluishGreen flex-1 font-semibold'
              }
              AccordionItemStyleContainer={{
                backgroundColor: 'rgba(242, 247, 249, 1)',
              }}
              icon={'IconBarChartSquare'}
            >
              <div className="bg-gray1 flex items-center flex-col justify-center gap-4 my-8">
                <div className="w-[160px] h-[160px]">
                  <CircularProgressbar
                    strokeWidth={5}
                    value={scorecard.percentage}
                    text={`${scorecard.percentage}%`}
                    styles={{
                      root: {},
                      path: {
                        stroke: scorecard.color,
                        transition: 'stroke-dashoffset 0.5s ease 0s',
                      },
                      text: {
                        fill: '#013546',
                        fontSize: '24px',
                        fontWeight: 700,
                        lineHeight: 40,
                      },
                    }}
                  />
                </div>
                <div className="items-center justify-center flex">
                  <p className="text-sm font-semibold  w-[80%]  text-text2 leading-6 text-center">
                    {scorecard.percentage == 100
                      ? 'Well done you reached 100%'
                      : scorecard.percentage == 0
                        ? 'Make a start to improve your score'
                        : 'Great start! But there is still room for improvement'}
                  </p>
                </div>
                <Accordion defaultActiveIndex={0}>
                  <AccordionItem
                    title={'Your score is broken down as follows:'}
                    isActive={false}
                    AccordionItemStyle={{ backgroundColor: '#FFFFFF' }}
                    AccordiontitleStyle={
                      'text-xs font-semibold text-text4 leading-5 flex-1'
                    }
                    AccordionItemStyleContainer={{
                      backgroundColor: '#FFFFFF',
                    }}
                  >
                    <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                      {trainingCategories?.data?.map((item, index) => {
                        const fieldsToCheck = getSafeguardingScoreFields(
                          item,
                          safeguardingRecordsData?.[index]
                        )

                        return (
                          <div key={index} className="">
                            <div className="">
                              <UIStaightlineProressBar
                                percentage={
                                  calculateNonNullPercentage(fieldsToCheck)
                                    .percentage
                                }
                                label={item?.title}
                                stroke={
                                  calculateNonNullPercentage(fieldsToCheck)
                                    .color
                                }
                                strokeWidth={1.5}
                              />
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </AccordionItem>
                </Accordion>
              </div>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
      <div className="bg-gray3 w-full h-[1px] my-3"></div>
      <div className="w-[33%] mt-6">
        <UIButton
          loading={isUpdateLoading}
          onClick={handleUpdateRecords}
          label="Update"
        />
        <Modal
          customStyle={{ width: '480px', borderRadius: 16 }}
          isOpen={isOpenAlert}
          onClose={() => {
            setIsOpenAlert(false)
          }}
        >
          <div
            className={
              'max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
            }
          >
            <div
              onClick={() => {
                setIsOpenAlert(false)
              }}
              className="flex w-[100%] justify-end cursor-pointer"
            >
              <Icon
                name={'IconCross'}
                stroke="#02698C"
                height={16}
                width={16}
              />
            </div>
            <div className="flex items-center w-[100%] justify-center">
              <Icon
                name={'IconAlertTriangle'}
                stroke={'#FF6666'}
                strokeWidth={1}
                height={52}
                width={52}
              />
            </div>
            <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
              <h1 className={'text-text2 text-[18px] font-bold'}>
                Save changes?
              </h1>
              <p className={'text-[14px] text-text1 font-normal'}>
                Do you want to save changes before moving on?{' '}
              </p>
            </div>

            <button
              onClick={() => {
                handleUpdateRecords()
                setIsOpenAlert(false)
              }}
              className=" text-textError border-textError border-[1px] min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
            >
              Save changes
            </button>
            <button
              onClick={() => {
                setIsOpenAlert(false)
              }}
              className=" text-text3 border-textError bg-gray2 min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
            >
              {`Don't save`}
            </button>
          </div>
        </Modal>
      </div>
    </div>
  )
}

export default SafeGuardingRecords
